if (!customElements.get('avendi-wet-weather')) {
customElements.define('avendi-wet-weather', class extends HTMLElement {
connectedCallback() {
if (this.initialized) return;
this.initialized=true;
this.select=this.querySelector('[data-jacket-size]');
this.button=this.querySelector('[data-offer-add]');
this.status=this.querySelector('[data-offer-status]');
this.select.addEventListener('change',()=>{this.button.disabled=!this.select.value;});
this.button.addEventListener('click',()=>this.addOffer());
}
async addOffer() {
if (!this.select.value || this.busy) return;
this.busy=true; this.button.disabled=true; this.status.textContent='';
try {
const response=await fetch(this.dataset.rootUrl+'cart.js',{headers:{Accept:'application/json'}});
if (!response.ok) throw new Error(this.dataset.error);
const cart=await response.json();
if(cart.currency!=='GBP') throw new Error(this.dataset.error);
const items=[{id:Number(this.select.value),quantity:1}];
if(!cart.items.some(item=>String(item.product_id)===this.dataset.bootId && item.quantity>0)) {
const form=this.closest('.buy-buttons-block')?.querySelector('form[data-type="add-to-cart-form"]');
const variant=form?.querySelector('[name="id"]');
const addButton=form?.querySelector('[name="add"]');
if(!variant?.value || addButton?.disabled) throw new Error(this.dataset.selectBoot);
items.unshift({id:Number(variant.value),quantity:1});
}
const added=await fetch(this.dataset.addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
const data=await added.json();
if(!added.ok) throw new Error(typeof data.description==='string'?data.description:this.dataset.error);
window.location.assign(this.dataset.cartUrl);
} catch(error) { this.status.textContent=error.message||this.dataset.error; this.busy=false; this.button.disabled=!this.select.value; }
}
});
}